import type { ChatMessage } from '@/messages/messageSlice';

const API_URL = import.meta.env.VITE_API_URL;
const JSON_HEADERS = { "Content-Type": "application/json", "Accept": "application/json" };

export type ChatSummary = { id: string; title: string; is_pinned?: boolean };

export async function login(username: string, password: string): Promise<{ userId: string, username: string, displayName: string }> {
  const response = await fetch(`${API_URL}/u/login`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ username, happy: password })
  });
  if (!response.ok) throw new Error(`Ooops, please try again.\r\n(${response.status})`);
  return await response.json() as { userId: string, username: string, displayName: string };
}

export async function fetchChatList(userId: string, limit = 20, offset = 0): Promise<ChatSummary[]> {
  if (!userId) return [];
  const url = `${API_URL}/c?userId=${userId}&limit=${limit}&offset=${offset}`;
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) throw new Error(`Failed to load chats (${res.status})`);
  const json = await res.json();
  return (json?.chats ?? []) as ChatSummary[];
}

export async function fetchMessageList(userId: string | null, chatId: string, limit = 20, offset = 0) {
  const response = await fetch(`${API_URL}/m/c/${chatId}?userId=${userId}&limit=${limit}&offset=${offset}`);
  if (!response.ok) throw new Error('Failed to load messages');
  return (await response.json())?.messages ?? [];
}

export async function sendMessage(userId: string | null, chatId: string | null | undefined, text: string, defaultThinking = true, defaultContext = true): Promise<ChatMessage> {
  const body = { userId : userId, chatId: chatId ?? null, text: text, defaultThinking: defaultThinking, defaultContext: defaultContext };
  const response = await fetch(`${API_URL}/m`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`Failed to send message: ${response.statusText}`);
  }

  const aiMessage = await response.json();
  aiMessage.role = 'ai'
  return aiMessage as ChatMessage;
}

